import React, { useEffect } from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';
import { Link } from 'react-router-dom';
import dashboardPreview from '../assets/dashboard_preview.png';

const LandingPage = () => {
  usePageMeta(
    'AskNow – Next Generation AI Intelligence',
    'Transform your business with AskNow’s AI platform: machine learning, predictive analytics, secure and reliable, lightning fast.'
  );

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.feature-card, .cta-content, .hero-visual-inner, .stat').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="main-landing-admin">
      <LandingNavbar />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container" style={{ alignItems: 'center' }}>
          <div className="hero-content" style={{ textAlign: 'left' }}>
            <h1 className="hero-title gradient-text" style={{ fontSize: '3.8rem' }}>
              Next Generation
              <br /><span className="gradient-ai" style={{ color: 'var(--color-primary)' }}>AI Intelligence</span>
            </h1>
            <p className="hero-description" style={{ fontSize: '1.25rem', color: 'rgba(255,255,255,0.85)', maxWidth: '540px' }}>
              Elevate your organization with AskNow. Manage AI chatbots, build knowledge bases, and harness the power of predictive analytics in one seamless platform.
            </p>
            <div className="hero-buttons" style={{ justifyContent: 'flex-start' }}>
              <Link to="/login" className="btn btn-primary">Get Started</Link>
              <Link to="/about" className="btn btn-secondary">Our Story</Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="featured-image-container">
              <img src={dashboardPreview} alt="Dashboard Preview" className="featured-image hero-image" />
            </div>
          </div>
        </div>
        <div className="hero-background">
          <div className="floating-shape shape-1"></div>
          <div className="floating-shape shape-2"></div>
          <div className="floating-shape shape-3"></div>
        </div>
      </section>

      {/* Quick Stats Section */}
      <section className="stats-preview" style={{ padding: '4rem 0' }}>
        <div className="container">
          <div className="stats" style={{ background: 'rgba(255,255,255,0.03)' }}>
            <div className="stat">
              <div className="stat-number">10M+</div>
              <div className="stat-label">Data Points</div>
            </div>
            <div className="stat">
              <div className="stat-number">500+</div>
              <div className="stat-label">Enterprises</div>
            </div>
            <div className="stat">
              <div className="stat-number">99.9%</div>
              <div className="stat-label">Reliability</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Overview */}
      <section className="features-preview" style={{ padding: '6rem 0' }}>
        <div className="container">
          <h2 className="section-title">Powerful <span>Capabilities</span></h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><i className="fas fa-robot"></i></div>
              <h3>Automated ML</h3>
              <p>Self-learning algorithms that evolve with your data patterns.</p>
              <Link to="/features" style={{ color: 'var(--color-accent)', textDecoration: 'none', fontSize: '0.9rem', marginTop: '1rem', display: 'inline-block' }}>Learn more →</Link>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><i className="fas fa-brain"></i></div>
              <h3>Advanced NLP</h3>
              <p>Human-like understanding for smarter customer interactions.</p>
              <Link to="/features" style={{ color: 'var(--color-accent)', textDecoration: 'none', fontSize: '0.9rem', marginTop: '1rem', display: 'inline-block' }}>Learn more →</Link>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><i className="fas fa-shield-alt"></i></div>
              <h3>Secure Vault</h3>
              <p>Enterprise-grade security for your sensitive knowledge base.</p>
              <Link to="/features" style={{ color: 'var(--color-accent)', textDecoration: 'none', fontSize: '0.9rem', marginTop: '1rem', display: 'inline-block' }}>Learn more →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Transform Your Business?</h2>
            <p className="cta-description">
              Start your journey today and see why top companies choose AskNow for their AI needs.
            </p>
            <div className="cta-buttons">
              <Link to="/login" className="btn btn-primary">Start Free Trial</Link>
              <Link to="/login" className="btn btn-secondary">Request Demo</Link>
            </div>
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
}

export default LandingPage;